import React, { Component } from "react";
import { connect } from "react-redux";
import "../style.css";
import { withRouter } from "react-router-dom";
import Addresses from "../../CheckoutProcess/Confirmation/Addresses";
import DriveEtaOutlinedIcon from "@material-ui/icons/DriveEtaOutlined";
import DirectionsWalkOutlinedIcon from "@material-ui/icons/DirectionsWalkOutlined";

class ServiceType extends Component {
  state = {
    drawerOpen: false,
  };

  renderPickupText = (language = null) => {
    const { settings } = this.props;
    language = language || this.props.language;
    const customTexts = settings.custom_texts;
    const pickup = settings.enable_pickup || settings.enable_pickup_select;
    const rbb = settings.enable_resource_based_booking;

    if (language == "english") {
      if (pickup && !rbb) return customTexts.pickup;
      else if (pickup && rbb) return "In store";
      else if (!pickup && rbb) return "Booking";
    } else {
      if (pickup && !rbb) return customTexts.pickup_ar;
      else if (pickup && rbb) return "عند الفرع";
      else if (!pickup && rbb) return "حجز";
    }
  };

  getServices = () => {
    const { settings, language, allow_only_pickup, allow_only_delivery } =
      this.props;
    let services = [];
    if (
      (settings.enable_delivery || settings.enable_delivery_select) &&
      (!allow_only_pickup || allow_only_delivery) &&
      !this.props.pickupOnly
    )
      services.push({
        type: 0,
        title: language === "arabic" ? "توصيل" : "Delivery",
        onClick:
          !this.props.auth.user ||
          !this.props.auth.addresses.length ||
          !settings.enable_social_auth
            ? () => {
                if (this.props.history.location.state?.fromMapPage)
                  this.props.history.replace("/checkout/address");
                this.props.setServiceType(0);
              }
            : () => this.setState({ drawerOpen: true }),
      });

    if (
      (settings.enable_pickup ||
        settings.enable_pickup_select ||
        settings.enable_resource_based_booking) &&
      this.props.branches?.filter((b) => b.enable_pickup)?.length &&
      !this.props.deliveryOnly
    )
      services.push({
        type: 1,
        title: this.renderPickupText(),
        onClick: () => {
          if (
            this.props.history.location.pathname === "/checkout/address" ||
            this.props.history.location.pathname === "/checkout/address/"
          ) {
            this.props.history.replace("/select/branch", {
              type: 1,
              fromMapPage: true,
              prevPage: "/checkout/address",
            });
          }
          this.props.setServiceType(1);
        },
      });

    return services;
  };

  render() {
    const { language, settings, themeColor, selectedServiceType } = this.props;
    const { drawerOpen } = this.state;
    const services = this.getServices();
    if (
      services.length <= 1 ||
      this.props.pickupOnly ||
      this.props.deliveryOnly
    )
      return <></>;
    const urlPathname = this.props.location.pathname;
    return (
      <div style={{ marginTop: 30 }}>
        {drawerOpen && (
          <Addresses
            open={drawerOpen}
            onClose={() => {
              this.setState({ drawerOpen: false });
              this.props.setServiceType(0);
            }}
            extraAction={() =>
              this.props.history.push("/checkout/confirmation")
            }
            comingFrom="deliveryTypeSelect"
            backText={
              language == "english" ? "Choose another area" : "اختر منطقة اخرى"
            }
          />
        )}
        <p
          className="box-title"
          style={{ textAlign: language === "arabic" ? "right" : "left" }}
        >
          {language == "arabic" ? "الطريقة" : "Method"}
        </p>

        {urlPathname === "/checkout/address" ||
        urlPathname === "/checkout/address/" ||
        (urlPathname === "/select/branch" &&
          this.props.location.state?.prevPage === "/checkout/address") ||
        this.props.location.state?.prevPage === "/checkout/address/" ? (
          <div
            className="bordered w-100 mx-0"
            style={{
              backgroundColor: "white",
              minHeight: 73,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
            dir={language === "english" ? "ltr" : "rtl"}
          >
            {services.map((service) => (
              <div
                style={{
                  backgroundColor:
                    service.type === selectedServiceType ? themeColor : "white",
                  color:
                    service.type === selectedServiceType ? "white" : themeColor,
                  border:
                    service.type === selectedServiceType
                      ? "1px solid white"
                      : `1px solid ${themeColor}`,
                  borderRadius: "3px",
                  width: "144px",
                  height: "42px",
                  marginRight: 15,
                  marginLeft: 15,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  userSelect: "none",
                  cursor: "pointer",
                }}
                onClick={service.onClick}
              >
                {service.type === 0 ? (
                  <>
                    <DriveEtaOutlinedIcon
                      style={{
                        color:
                          service.type === selectedServiceType
                            ? "white"
                            : themeColor,
                      }}
                    />
                    <span
                      style={{
                        marginLeft: language === "english" ? 15 : 0,
                        marginRight: language === "english" ? 0 : 15,
                        marginTop: 2,
                        lineHeight: "18px",
                        fontWeight: "bold",
                      }}
                    >
                      {service.title}
                    </span>
                  </>
                ) : (
                  <>
                    <DirectionsWalkOutlinedIcon
                      style={{
                        color:
                          service.type === selectedServiceType
                            ? "white"
                            : themeColor,
                      }}
                    />
                    <span
                      style={{
                        marginLeft: language === "english" ? 15 : 0,
                        marginRight: language === "english" ? 0 : 15,
                        marginTop: 2,
                        lineHeight: "18px",
                        fontWeight: "bold",
                      }}
                    >
                      {service.title}
                    </span>
                  </>
                )}
              </div>
            ))}
          </div>
        ) : (
          <div
            style={{
              display: "grid",
              gridTemplateColumns: `repeat(${services.length}, min-content)`,
              height: 105,
              paddingRight: 10,
              paddingLeft: 10,
              width: "100%",
              direction: language == "english" ? "ltr" : "rtl",
              alignItems: "center",
              backgroundColor: "white",
            }}
            className="w-100 bordered"
          >
            {services.map((service) => (
              <div
                style={{
                  marginRight: 8,
                  marginLeft: 8,
                  justifySelf: "center",
                  userSelect: "none",
                  cursor: "pointer",
                  width: 80,
                  height: 70,
                  border:
                    service.type === selectedServiceType
                      ? `2px solid ${themeColor}`
                      : "1px solid #cecece",
                  borderRadius: 4,
                  display: "grid",
                  alignItems: "center",
                  justifyContent: "center",
                }}
                onClick={service.onClick}
              >
                <div style={{ position: "relative", top: 5 }}>
                  {service.type === 0 ? (
                    <DriveEtaOutlinedIcon
                      style={{
                        color:
                          service.type === selectedServiceType
                            ? themeColor
                            : "grey",
                      }}
                    />
                  ) : (
                    <DirectionsWalkOutlinedIcon
                      style={{
                        color:
                          service.type === selectedServiceType
                            ? themeColor
                            : "grey",
                      }}
                    />
                  )}
                </div>
                <div
                  style={{
                    color:
                      service.type === selectedServiceType
                        ? themeColor
                        : "grey",
                    fontSize: "1rem",
                    position: "relative",
                    bottom: 3,
                  }}
                >
                  {service.title}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    countriesFullyLoaded: !state.store.thirdLoading,
    settings: state.store.store.settings,
    themeColor: state.store.store.settings.dark || "#0099cc",
    allow_only_pickup: state.cart.pickup_only_items > 0,
    allow_only_delivery: state.cart.delivery_only_items > 0,
    auth: state.auth,
    branches: state.store.store.branches,
  };
};
export default withRouter(connect(mapStateToProps)(ServiceType));
